import React, { useContext, useEffect, useMemo, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FormattedMessage } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';
import { Card } from 'src/components/card/Card';
import { AppLogo } from 'src/components/icon/AppLogo';
import { AccountIcon } from 'src/components/icon/Common';
import getConfig, { FEATURES } from 'src/services/config';
import { NEARXIDS } from 'src/services/near';
import { menuItemType, useMenus } from 'src/utils/menu';
import { useDCLAccountBalance } from '../../services/aurora/aurora';
import { ftGetTokensMetadata } from '../../services/ft-contract';
import { useTokenBalances } from '../../state/token';
import { useClientMobile, useMobile } from '../../utils/device';
import { toReadableNumber } from '../../utils/numbers';
import {
  getCurrentWallet,
  getSelectedWallet,
  WalletContext,
  getAccountName,
} from '../../utils/wallets-integration';
import { CopyIcon } from '../icon/CrossSwapIcons';
import {
  FiChevronRight,
  HiOutlineExternalLink,
  IoChevronBack,
} from '../reactIcons';
import { MobileNavBar } from './MobileNav';

import {
  useWalletSelector,
  ACCOUNT_ID_KEY,
} from 'src/context/WalletSelectorContext';
import { BuyNearButton } from '../button/Button';
import { DownTriangleIcon } from 'src/components/icon/Nav';
import { WalletRiskCheckBoxModal } from 'src/context/modal-ui/components/WalletOptions/WalletRiskCheckBox';
import { CONST_ACKNOWLEDGE_WALLET_RISK } from 'src/constants/constLocalStorage';
import { WalletSelectorModal } from './WalletSelector';
import { isNewHostName } from '../../services/config';
import { KeyIcon } from '../../components/portfolio/icons';
import AccessKeyModal from '../../components/portfolio/AccessKeyModal';

import { wrapHistoryMethodWithEvent } from '../../utils/historyEvents';
import { openUrl } from '../../utils/navigation';
export function AccountTipDownByAccountID({ show }: { show: boolean }) {
  return (
    <div
      className={`account-tip-popup  ${show ? 'block' : 'hidden'} text-xs`}
      style={{
        zIndex: 120,
      }}
    >
      <span>
        <em></em>
      </span>
      <FormattedMessage
        id="ref_account_tip_2"
        defaultMessage="You have token(s) in your REF Account"
      />
    </div>
  );
}

function AccountEntry({
  setShowWalletSelector,
  showWalletSelector,
  hasBalanceOnRefAccount,
}: {
  setShowWalletSelector: (show: boolean) => void;
  showWalletSelector: boolean;
  hasBalanceOnRefAccount: boolean;
}) {
  const history = useHistory();
  const [hover, setHover] = useState(false);

  const { globalState } = useContext(WalletContext);
  const { wallet } = getCurrentWallet();

  const [copyIconHover, setCopyIconHover] = useState<boolean>(false);

  const [showAccountTip, setShowAccountTip] = useState<boolean>(false);

  const [currentWalletName, setCurrentWalletName] = useState<string>();

  const [currentWalletIcon, setCurrentWalletIcon] = useState<string>();

  const { modal, accountId } = useWalletSelector();

  const [showTip, setShowTip] = useState<boolean>(false);
  const [copyButtonDisabled, setCopyButtonDisabled] = useState<boolean>(false);

  const [showWalletRisk, setShowWalletRisk] = useState<boolean>(false);
  const [keyModalShow, setKeyModalShow] = useState<boolean>(false);
  const handleWalletModalOpen = () => {
    const isAcknowledgeWalletRisk = localStorage.getItem(
      CONST_ACKNOWLEDGE_WALLET_RISK
    );
    if (!isAcknowledgeWalletRisk) {
      setShowWalletRisk(true);
    } else {
      modal.show();
    }
  };
  const handleAcknowledgeClick = (status) => {
    if (status === true) {
      setShowWalletRisk(false);
      localStorage.setItem(CONST_ACKNOWLEDGE_WALLET_RISK, '1');
      modal.show();
    }
  };

  const isSignedIn = globalState.isSignedIn;

  useEffect(() => {
    // A signed-out page has no selected wallet. Don't call wallet(), which
    // rejects with "No wallet selected".
    if (!accountId) {
      setCurrentWalletName(undefined);
      setCurrentWalletIcon(undefined);
      return;
    }
    let cancelled = false;
    getSelectedWallet(wallet)
      .then((selectedWallet) => {
        if (cancelled || !selectedWallet) return;
        setCurrentWalletName(selectedWallet.metadata.name);
        setCurrentWalletIcon(selectedWallet.metadata.iconUrl);
      })
      .catch((err) => {
        console.error(err);
      });
    return () => {
      cancelled = true;
    };
  }, [accountId]);

  useEffect(() => {
    setShowAccountTip(hasBalanceOnRefAccount);
  }, [hasBalanceOnRefAccount]);

  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAccountTip(false);
    }, 4000);

    return () => clearTimeout(timer);
  }, [showAccountTip]);

  const signOut = async () => {
    const curWallet = await getSelectedWallet(wallet);
    if (!curWallet) {
      localStorage.removeItem(ACCOUNT_ID_KEY);
      window.location.assign('/');
      return;
    }

    if (curWallet.id === 'sender') {
      //@ts-ignore
      await window.near.signOut();
    } else {
      await curWallet.signOut();
    }

    localStorage.removeItem(ACCOUNT_ID_KEY);

    window.location.assign('/');
  };

  const accountList = [
    {
      icon: <AccountIcon />,
      textId: 'your_assets',
      selected: location.pathname == '/overview',
      click: () => {
        history.push('/overview');
      },
    },
  ];

  function showToast() {
    if (copyButtonDisabled) return;
    setCopyButtonDisabled(true);
    setShowTip(true);
    setTimeout(() => {
      setShowTip(false);
      setCopyButtonDisabled(false);
    }, 1000);
  }
  function closeKeyModal() {
    setKeyModalShow(false);
  }
  function showkeyModal() {
    document.documentElement.style.overflow = 'visible';
    setKeyModalShow(true);
  }
  const isMobile = useClientMobile();
  const isDisableChangeWallet = ['keypom', 'Keypom Account'].includes(
    currentWalletName
  );

  return (
    <div
      className="bubble-box relative user text-xs text-center justify-end z-40"
      style={{
        zIndex: 51,
      }}
    >
      {showAccountTip ? (
        <AccountTipDownByAccountID show={showAccountTip} />
      ) : null}
      <div
        className={`cursor-pointer font-bold items-center justify-end text-center overflow-visible relative py-5`}
        onMouseEnter={() => {
          setShowAccountTip(false);
          setHover(true);
        }}
        onMouseLeave={() => {
          setHover(false);
        }}
      >
        <div
          className="flex items-center justify-center rounded-full text-sm"
          style={{
            padding: '6px 14px 6px 10px',
            border: '1px solid rgba(255, 255, 255, 0.16)',
            background: 'rgba(0, 0, 0, 0.28)',
            color: '#E7EEF2',
          }}
        >
          <span
            className="inline-block rounded-full mr-2 flex-shrink-0"
            style={{ width: 7, height: 7, background: '#3DDC97' }}
          />
          <div className="overflow-ellipsis overflow-hidden whitespace-nowrap account-name">
            {isSignedIn ? (
              <span
                className={`flex ml-1 items-center text-sm ${
                  hover ? 'text-white text-opacity-100' : ''
                }`}
              >
                {getAccountName(wallet.getAccountId())}
              </span>
            ) : (
              <button
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  //modal.show();
                  handleWalletModalOpen();
                  setHover(false);
                }}
                type="button"
              >
                <span className="ml-1 text-sm" style={{ color: '#E7EEF2' }}>
                  <FormattedMessage
                    id="connect_to_wallet"
                    defaultMessage="Connect Wallet"
                  />
                </span>
              </button>
            )}

            <WalletRiskCheckBoxModal
              isOpen={showWalletRisk}
              setCheckedStatus={handleAcknowledgeClick}
              onClose={() => setShowWalletRisk(false)}
            />
          </div>
        </div>
        {isSignedIn && hover ? (
          <div
            className={`absolute top-14 pt-2 right-0 w-64`}
            style={{ zIndex: 40 }}
          >
            <Card
              className="menu-max-height bg-cardBg cursor-default shadow-4xl "
              width="w-72"
              padding="py-4"
              style={{
                border: '1px solid #415462',
              }}
            >
              <div className="mx-7 flex justify-between items-start">
                <div className="text-white text-lg text-left flex-col flex">
                  <span>{getAccountName(wallet.getAccountId())}</span>

                  <span className="flex items-center ">
                    {currentWalletIcon && (
                      <span className="mr-1">
                        <img
                          src={currentWalletIcon}
                          className="w-3 h-3 mr-1"
                          alt=""
                        />
                      </span>
                    )}
                    <span className="text-xs text-primaryText">
                      {currentWalletName || '-'}
                    </span>
                  </span>
                </div>

                <div className="flex items-center">
                  <div className="flex items-center justify-center relative">
                    <CopyToClipboard
                      text={wallet.getAccountId()}
                      onCopy={showToast}
                    >
                      <div
                        className={` bg-opacity-20 rounded-lg flex items-center justify-center p-1.5 cursor-pointer`}
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                        onMouseEnter={() => {
                          !isMobile && setCopyIconHover(true);
                        }}
                        onMouseLeave={() => {
                          !isMobile && setCopyIconHover(false);
                        }}
                        onTouchStart={() => {
                          setCopyIconHover(true);
                        }}
                        onTouchEnd={() => {
                          setCopyIconHover(false);
                        }}
                      >
                        <CopyIcon
                          fillColor={copyIconHover ? '#4075FF' : '#7E8A93'}
                        />
                      </div>
                    </CopyToClipboard>
                    {showTip ? (
                      <span className="text-xs text-white rounded-lg px-2.5 py-1.5 absolute bottom-8 bg-mobileOrderBg z-50">
                        Copied!
                      </span>
                    ) : null}
                  </div>

                  <button
                    className="hover:text-gradientFrom text-primaryText ml-2"
                    onClick={() => {
                      openUrl(
                        `https://${
                          getConfig().networkId === 'testnet' ? 'testnet.' : ''
                        }nearblocks.io/address/${wallet.getAccountId()}#transaction`
                      );
                    }}
                  >
                    <HiOutlineExternalLink size={18} />
                  </button>
                </div>
              </div>

              <div className="flex mx-7 my-3 items-center text-xs justify-center">
                <button
                  className={`mr-2 w-1/2 py-1.5 border rounded-lg border-opacity-30 ${
                    isDisableChangeWallet
                      ? 'border-gray-500 text-gray-500 cursor-default'
                      : 'text-BTCColor hover:border-transparent hover:bg-opacity-20 hover:bg-BTCColor border-BTCColor'
                  }`}
                  onClick={() => {
                    signOut();
                  }}
                  disabled={isDisableChangeWallet}
                >
                  <FormattedMessage
                    id="disconnect"
                    defaultMessage={'Disconnect'}
                  />
                </button>

                <button
                  className={`ml-2 w-1/2 py-1.5 border rounded-lg border-opacity-30 ${
                    isDisableChangeWallet
                      ? 'border-gray-500 text-gray-500 cursor-default'
                      : 'text-gradientFrom border-gradientFrom hover:border-transparent hover:bg-gradientFrom hover:bg-opacity-20'
                  }`}
                  onClick={async () => {
                    modal.show();
                  }}
                  disabled={isDisableChangeWallet}
                >
                  <FormattedMessage id="change" defaultMessage={'Change'} />
                </button>
              </div>

              <div
                className="my-3 mx-7 "
                style={{
                  borderBottom: '1px solid rgba(126, 138, 147, 0.3)',
                }}
              ></div>

              {accountList.map((account, index) => {
                return (
                  <React.Fragment key={account.textId + index}>
                    <div
                      onClick={account.click}
                      key={account.textId + index}
                      className={`flex items-center mx-3 text-sm cursor-pointer font-semibold py-4 pl-3 hover:text-white hover:bg-black rounded-lg hover:bg-opacity-10 ${
                        account.selected
                          ? 'text-white bg-black bg-opacity-10'
                          : 'text-primaryText'
                      }`}
                    >
                      <label className="w-9 text-left cursor-pointer">
                        {account.icon}
                      </label>
                      <label className="cursor-pointer text-base">
                        <FormattedMessage id={account.textId} />
                      </label>
                    </div>
                    <div
                      onClick={showkeyModal}
                      className="flex items-center mx-3 text-sm cursor-pointer font-semibold py-4 pl-3 hover:text-white hover:bg-black rounded-lg hover:bg-opacity-10 text-primaryText"
                    >
                      <label className="w-9">
                        <KeyIcon />
                      </label>
                      <label className="cursor-pointer text-base">
                        Approved Key
                      </label>
                    </div>
                    {hasBalanceOnRefAccount &&
                    account.textId === 'your_assets' ? (
                      <div
                        className="text-center py-0.5 font-normal bg-gradientFrom w-full cursor-pointer text-xs"
                        onClick={account.click}
                        style={{
                          color: '#001320',
                        }}
                      >
                        <FormattedMessage
                          id="ref_account_tip_2"
                          defaultMessage="You have token(s) in your REF Account"
                        />
                      </div>
                    ) : null}
                  </React.Fragment>
                );
              })}
            </Card>
          </div>
        ) : null}
      </div>
      {accountId && keyModalShow ? (
        <AccessKeyModal isOpen={keyModalShow} onRequestClose={closeKeyModal} />
      ) : null}
    </div>
  );
}

function NavigationBar() {
  const { globalState } = useContext(WalletContext);

  const isSignedIn = globalState.isSignedIn;

  const [showWalletSelector, setShowWalletSelector] = useState(false);

  const [hoverClick, setHoverClick] = useState<boolean>(false);

  const isMobile = useMobile();

  const [tokensMeta, setTokensMeta] = useState<{}>();

  const [pathnameState, setPathnameState] = useState<boolean>(
    window.location.pathname !== '/account'
  );
  const setPatheState = () =>
    setPathnameState(window.location.pathname !== '/account');

  useEffect(() => {
    history.pushState = wrapHistoryMethodWithEvent('pushState');
    history.replaceState = wrapHistoryMethodWithEvent('replaceState');
    window.addEventListener('popstate', (event) => {
      setPatheState();
    });
    window.addEventListener('pushState', function () {
      setPatheState();
    });
    window.addEventListener('replaceState', function () {
      setPatheState();
    });
  }, []);

  const [hasBalanceOnRefAccount, setHasBalanceOnRefAccount] =
    useState<boolean>(false);

  const refAccountBalances = useTokenBalances();

  const dclAccountBalances = useDCLAccountBalance(isSignedIn);

  useEffect(() => {
    if (!refAccountBalances || !dclAccountBalances) return;

    const ids = Object.keys(refAccountBalances).concat(
      Object.keys(dclAccountBalances)
    );

    ftGetTokensMetadata(ids).then(setTokensMeta);
  }, [
    Object.values(refAccountBalances || {}).join('-'),
    Object.values(dclAccountBalances || {}).join('-'),
    refAccountBalances,
    isSignedIn,
  ]);

  useEffect(() => {
    if (!refAccountBalances || !tokensMeta || !dclAccountBalances) {
      setHasBalanceOnRefAccount(false);
      return;
    }
    const hasRefBalanceOver = Object.entries(refAccountBalances).some(
      ([id, balance]) => {
        if (id === NEARXIDS[0]) return false;
        return (
          Number(
            toReadableNumber(tokensMeta?.[id]?.decimals || 24, balance) || '0'
          ) > 0.001
        );
      }
    );

    const hasDCLBalanceOver = Object.entries(dclAccountBalances).some(
      ([id, balance]) => {
        return (
          Number(
            toReadableNumber(
              tokensMeta?.[id]?.decimals || 24,
              balance as string
            ) || '0'
          ) > 0
        );
      }
    );

    setHasBalanceOnRefAccount(hasRefBalanceOver || hasDCLBalanceOver);
  }, [
    refAccountBalances,
    dclAccountBalances,
    Object.values(refAccountBalances || {}).join('-'),
    Object.values(dclAccountBalances || {}).join('-'),
    tokensMeta,
    isSignedIn,
  ]);

  return (
    <>
      <div
        className="nav-wrap md:hidden xs:hidden text-center relative"
        style={{ zIndex: '91' }}
      >
        <div
          className={`relative z-10 ${
            hasBalanceOnRefAccount && pathnameState ? 'block' : 'hidden'
          } text-xs py-1.5`}
          style={{
            backgroundColor: '#FFC940',
          }}
        >
          👀 &nbsp;
          <FormattedMessage
            id="ref_account_balance_tip"
            defaultMessage="It seems like an error occurred while adding/removing liquidity to the pool"
          />
          {`, `}
          <FormattedMessage
            id="ref_account_tip_top"
            defaultMessage="your token(s) may be now in your Ref inner account"
          />
          {`.`}
          <span
            className={`${
              hoverClick ? 'font-bold' : 'font-normal'
            } underline cursor-pointer mx-1`}
            onClick={() => openUrl('/account?tab=ref')}
            onMouseEnter={() => setHoverClick(true)}
            onMouseLeave={() => setHoverClick(false)}
          >
            <FormattedMessage id="click_here" defaultMessage="Click here" />
          </span>
          <FormattedMessage
            id="to_recover_them"
            defaultMessage="to recover them"
          />
          .
        </div>
        <nav
          className="flex items-center justify-between px-8"
          style={{
            height: '64px',
            background: 'rgba(8, 12, 16, 0.55)',
            backdropFilter: 'blur(16px)',
            WebkitBackdropFilter: 'blur(16px)',
            borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
          }}
        >
          <div className="flex items-center h-full">
            <div className="xsm:hidden transform mr-10 relative z-10">
              <AppLogo
                size={18}
                className="cursor-pointer"
                onClick={() => {
                  window.location.href = '/';
                }}
              />
            </div>
            <div className="flex items-center h-full">
              <ZearNavLinks />
            </div>
          </div>
          <div className="flex items-center justify-end">
            {isMobile || !FEATURES.buyNear ? null : <BuyNearButton />}

            <div className="flex items-center mx-3">
              <AccountEntry
                hasBalanceOnRefAccount={hasBalanceOnRefAccount}
                setShowWalletSelector={setShowWalletSelector}
                showWalletSelector={showWalletSelector}
              />
              {/*<div className={isSignedIn ? 'flex items-center' : 'hidden'}>*/}
              {/*  <ConnectDot />*/}
              {/*  <ConnectDot />*/}
              {/*  <AuroraEntry hasBalanceOnAurora={hasAuroraBalance} />*/}
              {/*</div>*/}
            </div>
          </div>
        </nav>
        {/* {isMobile ? null : <Marquee></Marquee>} */}
      </div>

      {isMobile && (
        <MobileNavBar
          hasBalanceOnRefAccount={hasBalanceOnRefAccount}
          isSignedIn={isSignedIn}
          setShowWalletSelector={setShowWalletSelector}
          showWalletSelector={showWalletSelector}
          hasAuroraBalance={false}
        />
      )}

      <WalletSelectorModal
        setShowWalletSelector={setShowWalletSelector}
        isOpen={showWalletSelector}
        onRequestClose={() => {
          window.location.reload();
          setShowWalletSelector(false);
        }}
      />
    </>
  );
}

export default NavigationBar;

function ZearNavLinks() {
  const location = useLocation();
  const history = useHistory();
  const path = location.pathname;
  const links = [
    {
      label: 'Swap',
      href: '/',
      active: path === '/' || path === '/swap',
    },
    {
      label: 'Liquidity',
      href: '/pools',
      active:
        path.startsWith('/pool') ||
        path.startsWith('/yourliquidity') ||
        path.startsWith('/addLiquidity') ||
        path.startsWith('/yoursLiquidity'),
    },
  ];

  return (
    <div className="flex items-center">
      {links.map((link) => (
        <button
          key={link.label}
          type="button"
          onClick={() => {
            if (link.href) history.push(link.href);
          }}
          className="text-sm font-medium bg-transparent"
          style={{
            color: link.active ? '#F4F7F8' : '#8B969E',
            border: link.active
              ? '1px solid rgba(232, 236, 239, 0.55)'
              : '1px solid transparent',
            borderRadius: 8,
            padding: '5px 12px',
            marginRight: 4,
            cursor: link.href ? 'pointer' : 'default',
            lineHeight: 1.2,
          }}
        >
          {link.label}
        </button>
      ))}
    </div>
  );
}

function MenuBar() {
  const history = useHistory();
  const [hover_two_level_items, set_hover_two_level_items] = useState<
    menuItemType[]
  >([]);
  const [hover_one_level_id, set_hover_one_level_id] = useState<string>();

  const [hover_two_level_id, set_hover_two_level_id] = useState<string>();

  const [back_one_level_item, set_back_one_level_item] =
    useState<JSX.Element>();
  const [one_level_selected, set_one_level_selected] = useState<string>('');
  const [two_level_selected, set_two_level_selected] = useState<string>('');

  function hover_on_one_level_item(menuItem: menuItemType) {
    const { children, id } = menuItem;
    if (children) {
      set_hover_two_level_items(children);
    }
    set_hover_one_level_id(id);
  }

  function hover_off_one_level_item() {
    set_hover_two_level_items([]);
    set_back_one_level_item(null);
    set_hover_two_level_id(undefined);
    set_hover_one_level_id('');
  }

  function click_one_level_item(menuItem: menuItemType) {
    const { clickEvent, url, isExternal } = menuItem;
    if (clickEvent) {
      clickEvent();
    } else if (url) {
      if (isExternal) {
        openUrl(url);
      } else {
        history.push(url);
      }
    }
    if (clickEvent && url) {
      hover_off_one_level_item();
    }
  }

  function click_two_level_item(menuItem: menuItemType) {
    const { children, label, clickEvent, url, isExternal } = menuItem;
    if (children) {
      set_hover_two_level_items(children);
      set_back_one_level_item(label);
    } else {
      if (clickEvent) {
        clickEvent();
      } else if (url) {
        if (isExternal) {
          openUrl(url);
        } else {
          history.push(url);
        }
      }

      if (clickEvent) {
        hover_off_one_level_item();
      }
    }
  }

  function click_three_level_title_to_back(menuItem: menuItemType) {
    const { children } = menuItem;
    set_hover_two_level_items(children);
    set_back_one_level_item(null);
  }

  const menus_temp = useMenus(() => {
    hover_off_one_level_item();
    set_hover_two_level_id(undefined);
  });
  const menus = useMemo(() => {
    if (menus_temp) {
      const menus_final = menus_temp.filter((menuItem: menuItemType) => {
        return !menuItem.hidden;
      });
      return menus_final;
    }
  }, [menus_temp]);
  useEffect(() => {
    const pathname = '/' + location.pathname.split('/')[1];
    let one_level_selected_id = '';
    let two_level_selected_id = '';
    const swap_mode_in_localstorage =
      localStorage.getItem('SWAP_MODE_VALUE') || 'normal';

    if (menus) {
      const one_level_menu = menus.find((menuItem: menuItemType) => {
        const { links } = menuItem;
        return links?.indexOf(pathname) > -1;
      });
      if (one_level_menu) {
        const { id, children } = one_level_menu;
        one_level_selected_id = id;
        const second_children: any = children;
        if (second_children) {
          const two_level_menu = second_children.find(
            (menuItem: menuItemType) => {
              const { links, swap_mode } = menuItem;
              const condition = isNewHostName
                ? pathname == '/swap'
                : pathname == '/' || pathname == '/swap';
              if (condition) {
                return swap_mode_in_localstorage == swap_mode;
              } else {
                return links?.indexOf(pathname) > -1;
              }
            }
          );
          if (two_level_menu) {
            two_level_selected_id = two_level_menu.id;
          }
        }
      } else {
        menus.find((menuItem) => {
          const match = menuItem.links.includes(pathname);
          if (!match && Array.isArray(menuItem.children)) {
            const level2Match = menuItem.children.find((childMenuItem) =>
              childMenuItem.links?.includes(pathname)
            );

            if (level2Match) {
              two_level_selected_id = level2Match.id;
              one_level_selected_id = menuItem.id;
            }
          }
          return match;
        });
      }

      set_one_level_selected(one_level_selected_id);
      set_two_level_selected(two_level_selected_id);
    }
  }, [location.pathname, menus]);
  return (
    <div className="flex items-center h-full z-50">
      {menus?.map((menuItem: menuItemType, indexP) => {
        const { label, logo, children, id } = menuItem;
        return (
          <div
            id={`menu-${id}`}
            key={indexP}
            className="relative flex items-center justify-center cursor-pointer h-full z-50"
            onMouseEnter={() => hover_on_one_level_item(menuItem)}
            onMouseLeave={() => hover_off_one_level_item()}
          >
            {/* one-level */}
            <div
              onClick={() => {
                click_one_level_item(menuItem);
              }}
              className={`flex items-center h-full border-b-2 ${
                indexP != menus.length - 1 ? 'mr-8' : ''
              } ${
                one_level_selected == id || hover_one_level_id == id
                  ? 'text-white border-white'
                  : 'text-primaryText border-transparent'
              }`}
            >
              {logo ? <span className="mr-1">{logo}</span> : null}
              <div className="text-sm font-medium">{label}</div>
              {children ? (
                <DownTriangleIcon className="ml-1 mt-1"></DownTriangleIcon>
              ) : null}
            </div>
            {/* two-level */}
            <div
              className={`absolute rounded-2xl border border-menuMoreBoxBorderColor bg-priceBoardColor top-12 cursor-pointer px-2.5 py-1 pc-menu-bar-one-level ${
                hover_one_level_id == id &&
                children &&
                hover_two_level_items.length > 0
                  ? ''
                  : 'hidden'
              }`}
              style={{ minWidth: '220px', left: '-80px' }}
            >
              {back_one_level_item && (
                <div
                  className="whitespace-nowrap hover:text-white text-left items-center flex justify-start text-sm  text-primaryText cursor-pointer pt-4 pb-2"
                  onClick={() => {
                    click_three_level_title_to_back(menuItem);
                  }}
                >
                  <IoChevronBack className="text-xl " />
                  <span className="ml-3">{back_one_level_item}</span>
                </div>
              )}
              {hover_two_level_items?.map(
                (childMenuItem: menuItemType, indexC) => {
                  const {
                    label,
                    logo,
                    children,
                    id: id_two_level,
                    icon,
                    hoverLabel,
                    renderLogo,
                  } = childMenuItem;
                  return (
                    <div
                      key={indexC}
                      onClick={() => {
                        click_two_level_item(childMenuItem);
                      }}
                      onMouseEnter={() => {
                        set_hover_two_level_id(id_two_level);
                      }}
                      onMouseLeave={() => {
                        set_hover_two_level_id(id_two_level);
                      }}
                      className={`flex items-center rounded-xl whitespace-nowrap hover:bg-menuMoreBgColor hover:text-white text-sm py-3 my-1.5 px-2 cursor-pointer ${
                        two_level_selected == id_two_level
                          ? 'bg-menuMoreBgColor text-white'
                          : 'text-primaryText'
                      }`}
                    >
                      {logo || renderLogo ? (
                        <div className="w-8 mr-2">
                          {renderLogo
                            ? renderLogo({
                                activeMenu: two_level_selected == id_two_level,
                              })
                            : logo}
                        </div>
                      ) : null}
                      <div className="text-base ">
                        {hover_two_level_id == id_two_level && hoverLabel
                          ? hoverLabel
                          : label}
                      </div>
                      {children ? (
                        <span className="text-xl ml-2">
                          <FiChevronRight />
                        </span>
                      ) : null}
                      {icon ? (
                        <span className="ml-4 text-xl">{icon}</span>
                      ) : null}
                    </div>
                  );
                }
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
